/**
 * Encoder for FormData entries (require FormDataReader to read it)
 * TODO test with input[type=file]
 * @class FormDataEncoder
 * @constructor
 */
function FormDataEncoder(){
	this._fileLoadEndedHandlerBound = this._fileLoadEndedHandler.bind(this);
}

FormDataEncoder.prototype._result = null;
FormDataEncoder.prototype._readyState = 0;
FormDataEncoder.prototype._entries = null;
/**
 * @type {Array.<_FormDataSetEntry>}
 * @private
 */
FormDataEncoder.prototype._filesEntries = null;
/**
 * @type {Array.<FileReader>}
 * @private
 */
FormDataEncoder.prototype._filesReaders = null;
/**
 * @type {number}
 * @private
 */
FormDataEncoder.prototype._numLoadedFiles = 0;
FormDataEncoder.prototype._asyncEnd = null;

Object.defineProperty(FormDataEncoder.prototype, "result", {
	get: function(){
		return this._result;
	}
});

Object.defineProperty(FormDataEncoder.prototype, "readyState", {
	get: function(){
		return this._readyState;
	}
});
FormDataEncoder.EMPTY = 0;
FormDataEncoder.LOADING = 1;
FormDataEncoder.DONE = 2;

FormDataEncoder._ASYNC_HASH = "hash";
FormDataEncoder._ASYNC_ENC_FORM_DATA = "encode_form-data";

/**
 * "Replace every occurrence of a "CR" (U+000D) character not followed by a "LF" (U+000A) character, and every occurrence of a "LF" (U+000A) character not preceded by a "CR" (U+000D) character, by a two-character string consisting of a U+000D CARRIAGE RETURN "CRLF" (U+000A) character pair."
 * Not required for textarea and input[type=file]
 * @param {string} value
 * @returns {string}
 */
FormDataEncoder.normalizeEntryField = function normalizeEntryField(value){
	return value.replace(/\r([^\n]|$)/g, "\r\n$0").replace(/(^|[^\r])\n/g, "$0\r\n");
};

/**
 * Convert FormDataSet to String according given encoding
 * Charset is not supported (only UTF-8)
 * @param {Array.<Object>} entries
 * @param {String} [encoding=application/x-www-form-urlencoded] Different than charset encoding
 * @see http://www.w3.org/TR/html5/infrastructure.html#encoding
 * @see http://www.w3.org/TR/html5/forms.html#picking-an-encoding-for-the-form
 */
FormDataEncoder.prototype.encode = function encode(entries, encoding){
	if(this._readyState != FormDataEncoder.EMPTY && this._readyState != FormDataEncoder.DONE){
		throw Error("Invalid call");
	}
	this._result = null;
	var result = "";
	// Default values
	if(encoding === undefined){
		encoding = "application/x-www-form-urlencoded";//"application/x-www-form-urlencoded; charset=UTF-8"
	}
	var charset = "UTF-8";
	// Other charset for non encodable char will be: &#0123; where 0123 is ASCII digits represent the unicode code point in base 10

	var entry;
	var value;
	var entryIndex;
	var numEntries = entries.length;

	// http://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
	// http://stackoverflow.com/questions/4526273/what-does-enctype-multipart-form-data-mean
	switch(encoding){
		case "application/x-www-form-urlencoded":
			// www.w3.org/TR/html5/forms.html#application/x-www-form-urlencoded-encoding-algorithm
			for(entryIndex = 0; entryIndex < numEntries; entryIndex++){
				entry = entries[entryIndex];
				// Skip entries with an empty name
				if(!entry.name){
					continue;
				}

				// https://developers.whatwg.org/association-of-controls-and-forms.html#attr-fe-name-isindex
				if(entryIndex == 0 && entry.name == "isindex"){
					result += encodeURIComponent(entry.value);
					continue;
				}

				// If input[type=file] value will be the filename
				// Entry file's value is the filename
				if(entry.type == "file"){
					value = entry.value.name;
				}
				// if entry input[type=hidden][name=_charset_] change value to encoding charset
				// https://developers.whatwg.org/association-of-controls-and-forms.html#attr-fe-name-charset
				else if(entry.name == "_charset_" && entry.type == "hidden"){
					value = charset;
				}
				else{
					value = entry.value;
				}

				if(entryIndex > 0){
					result += "&";
				}
				// Encode
				result += encodeURIComponent(entry.name) + "=" + encodeURIComponent(value);
			}
			// Replace space char with "+"
			this._result = result = result.replace(/%20/g, "+");
			this._readyState = FormDataEncoder.DONE;
			break;
		case "multipart/form-data":
			var filesEntries = [];
			this._entries = entries;
			for(entryIndex = 0; entryIndex < numEntries; entryIndex++){
				entry = entries[entryIndex];
				if(entry.type == "file"){
					filesEntries.push(entry);
				}
			}

			if(filesEntries.length > 0){
				// Async
				this._readyState = FormDataEncoder.LOADING;
				this._loadFiles(filesEntries);
			}else{
				// Sync
				this._encodeFormData();
			}
			break;
		case "text/plain":
			// http://www.w3.org/TR/html5/forms.html#text/plain-encoding-algorithm
			for(entryIndex = 0; entryIndex < numEntries; entryIndex++){
				entry = entries[entryIndex];
				// If input[type=file] value will be the filename
				// Entry file's value is the filename
				if(entry.type == "file"){
					value = entry.value.name;
				}
				// if entry input[type=hidden][name=_charset_] change value to encoding charset
				// https://developers.whatwg.org/association-of-controls-and-forms.html#attr-fe-name-charset
				else if(entry.name == "_charset_" && entry.type == "hidden"){
					value = charset;
				}
				else{
					value = entry.value;
				}
				result += entry.name + "=" + value + "\r\n";
			}

			this._result = result;
			this._readyState = FormDataEncoder.DONE;
			break;
		default:
			throw new TypeError("Invalid encoding");
	}
};

FormDataEncoder.prototype._loadFiles = function _loadFiles(filesEntries){
	this._filesEntries = filesEntries;
	var numEntries = filesEntries.length;
	this._filesReaders = new Array(numEntries);
	this._numLoadedFiles = 0;

	for(var fileReader, entry, entryIndex = 0; entryIndex < numEntries; entryIndex++){
		fileReader = new FileReader();
		this._filesReaders[entryIndex] = fileReader;
		fileReader.addEventListener("loadend", this._fileLoadEndedHandlerBound);
		// Start loading file
		fileReader.readAsBinaryString(entry.value);
	}
};

FormDataEncoder.prototype.hash = function hash(entries, withoutFilesContent){
	if(this._readyState != FormDataEncoder.EMPTY && this._readyState != FormDataEncoder.DONE){
		throw Error("Invalid call");
	}
	var entry;
	var entryIndex;
	var numEntries;
	this._entries = entries;
	var filesEntries = [];
	if(!withoutFilesContent){
		for(entryIndex = 0, numEntries = entries.length; entryIndex < numEntries; entryIndex++){
			entry = entries[entryIndex];
			if(entry.type == "file"){
				filesEntries.push(filesEntries);
			}
		}
	}

	// Async
	if(filesEntries.length > 0){
		this._result = null;
		this._readyState = FormDataEncoder.LOADING;
		this._loadFiles(filesEntries);
	}
	// Sync
	else{
		this._generateHash();
	}
};

FormDataEncoder.prototype._fileLoadEndedHandler = function _fileLoadEndedHandler(event){
	if(event.target.error){
		this._release(true);
		this._result = null;
		this._readyState = FormDataEncoder.EMPTY;
		// TODO dispatch error instead of throwing it
		throw new Error("File read error: " + event.target.error.name);
	}

	if(++this._numLoadedFiles > this._filesReaders.length){
		switch(this._asyncEnd){
			case FormDataEncoder._ASYNC_HASH:
				this._generateHash();
				break;
			case FormDataEncoder._ASYNC_ENC_FORM_DATA:
				this._encodeFormData();
				break;
		}
	}
};

/**
 * Relase resources will not be further used
 * @param {Boolean} [abort=false] If true, abort file readers
 * @private
 */
FormDataEncoder.prototype._release = function _release(abort){
	for(var reader, readerIndex = 0, numReaders = this._filesReaders; readerIndex < numReaders; readerIndex++){
		reader = this._filesReaders[readerIndex];
		reader.removeEventListener("loadend", this._fileLoadEndedHandlerBound);
		if(abort){
			reader.abort();
		}
	}
	this._entries = null;
	this._filesEntries = this._filesReaders = null;
	this._numLoadedFiles = 0;
};

FormDataEncoder.prototype._generateHash = function _generateHash(){
	// Will contains data provided by all entries
	var str = "";
	var entry;
	var entryIndex;
	var numEntries = this._entries.length;
	if(this._numLoadedFiles > 0){
		for(entryIndex = 0; entryIndex < numEntries; entryIndex++){
			entry = this._entries[entryIndex];
			// Entry is a file. Use its name and content
			if(entry.type == "file"){
				str += entry.name + entry.value.name + this._filesReaders[this._filesEntries.indexOf(entry)].result;
			}else{
				str += entry.name + entry.value;
			}
		}
	}else{
		for(entryIndex = 0; entryIndex < numEntries; entryIndex++){
			entry = this._entries[entryIndex];
			// Entry is a file. Use its name, size, type and last modified date
			if(entry.type == "file"){
				str += entry.name + entry.value.name + entry.value.size + entry.value.type + entry.value.lastModifiedDate.value;
			}else{
				str += entry.name + entry.value;
			}
		}
	}

	// Create a hash from str
	// http://erlycoder.com/49/javascript-hash-functions-to-convert-string-into-integer-hash-
	var hash = 5381;
	for (var i = 0; i < str.length; i++) {
		hash = ((hash << 5) + hash) + str.charCodeAt(i); /* hash * 33 + c */
	}

	this._release();
	this._result = hash;
	this._readyState = FormDataEncoder.DONE;
};

FormDataEncoder.prototype._encodeFormData = function _encodeFormData(){
	// http://www.w3.org/TR/html5/forms.html#multipart/form-data-encoding-algorithm
	// http://www.w3.org/TR/html5/forms.html#introduction-2
	// https://developer.mozilla.org/en-US/docs/Web/API/FileReader.readAsBinaryString
	//TODO
	// "/Users/mems/Materials/Programming/Web/Front/Flash, ActionScript/Nodes.md#Upload-file-with-URLLoader"
	//use FormDataEncoder.normalizeEntryField();
	this._release();
	this._result = "";
	this._readyState = FormDataEncoder.DONE;
};